var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_2747)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_48_2747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7651 10.4927L13.8687 5.70789L4.02936 15.323L8.92576 20.1078L18.7651 10.4927Z",
    fill: "#F1C25A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2185 7.11825L17.3221 2.33344L13.869 5.70783L18.7654 10.4927L22.2185 7.11825Z",
    fill: "#27353B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3875 3.2496L16.1392 3.49225L21.0356 8.27707L21.2839 8.03441L16.3875 3.2496Z",
    fill: "#006577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0455 4.56045L14.7971 4.8031L19.6935 9.58792L19.9419 9.34527L15.0455 4.56045Z",
    fill: "#006577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93278 20.1027C9.10837 19.9311 8.87791 19.4378 8.42798 18.9981C8.10974 18.6871 7.75857 18.4834 7.51715 18.4512C7.42935 18.4512 7.36351 18.3761 7.35254 18.2903C7.31962 18.0544 7.12208 17.7113 6.79287 17.4003C6.46365 17.0893 6.12346 16.8855 5.88203 16.8533C5.79424 16.8533 5.72839 16.7783 5.71742 16.6925C5.6845 16.4566 5.48697 16.1134 5.15775 15.8024C4.70782 15.3627 4.20302 15.1375 4.02743 15.3091L1.8107 22.2582L8.92181 20.092L8.93278 20.1027Z",
    fill: "#FFF7DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82169 22.2689L4.81757 21.3573L2.75447 19.3412L1.82169 22.2689Z",
    fill: "#27353B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9904 1.58254C21.6406 0.263503 19.4458 0.263503 18.096 1.58254L17.3279 2.33321L22.2222 7.11605L22.9904 6.36538C24.3402 5.04635 24.3402 2.90157 22.9904 1.58254Z",
    fill: "#F1625C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5734 23.9739H0.186557C0.0835244 23.9739 0 24.0556 0 24.1562V24.4136C0 24.5143 0.0835244 24.5959 0.186557 24.5959H22.5734C22.6764 24.5959 22.7599 24.5143 22.7599 24.4136V24.1562C22.7599 24.0556 22.6764 23.9739 22.5734 23.9739Z",
    fill: "#27353B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_2747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.595947)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_48_2747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.595947)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.c6404bb5c4e14718d8972ee6fad1ffc1.svg";
export { ForwardRef as ReactComponent };